import { v5 as uuidv5 } from 'uuid';

// Stable namespace UUID (v4-shaped) used to scope all AP-purchase-invoice
// idempotency keys. The namespace value itself is arbitrary; what matters is
// that it never changes — rotating it would break dedupe across deploys.
const AP_INVOICE_NAMESPACE = '11111111-1111-4111-8111-111111111111';

// Derive a deterministic idempotency key from `(request id, updated_at,
// action)`. Two clicks for the same action against the same row revision
// produce the same key, so the backend dedupes the second call.
export function deriveIdempotencyKey(
  requestId: string,
  updatedAt: string,
  action: string,
): string {
  return uuidv5(`${requestId}:${updatedAt}:${action}`, AP_INVOICE_NAMESPACE);
}
